import './CalendarItem.css';
export var calendarButton = '_1basjc2-3-8-0';
export var currentIndicator = '_1basjc1-3-8-0';
export var headerButton = '_1basjc3-3-8-0';
export var outOfScopeDay = '_1basjc0-3-8-0';